import { Lang } from './types';

const typeSafeLangs: {[k in Lang]: true} = {es: true, en: true};
const allLangs = Object.keys(typeSafeLangs);

const isLang = (value: unknown): value is Lang =>
    (allLangs as unknown[]).includes(value);

export const langOrDefault = (lang: unknown, defaultLang: Lang): Lang =>
    isLang(lang) ? lang : defaultLang;